import { defineComponent, ref, createBlock, openBlock, unref, withCtx, createTextVNode, toDisplayString, renderSlot, createCommentVNode } from "vue";
import { r as register, a as t } from "./_l10n-DbErv0fW.mjs";
import { N as NcButton } from "./NcButton-DkC5k3Lb.mjs";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-5AA93z-F.mjs";
import { N as NcLoadingIcon } from "./NcLoadingIcon-b_ajZ_nQ.mjs";
register();
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcDialogButton",
  props: {
    callback: { type: Function, default: () => {
    } },
    disabled: { type: Boolean, default: false },
    icon: { default: void 0 },
    label: {},
    type: { default: "button" },
    variant: { default: "tertiary" }
  },
  emits: ["click"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const isLoading = ref(false);
    async function handleClick(e) {
      if (isLoading.value) {
        return;
      }
      isLoading.value = true;
      try {
        const fallback = props.type === "reset" ? false : void 0;
        const result = await props.callback?.() ?? fallback;
        if (result !== false) {
          emit("click", e, result);
        }
      } finally {
        isLoading.value = false;
      }
    }
    return (_ctx, _cache) => {
      return openBlock(), createBlock(unref(NcButton), {
        "aria-label": _ctx.label,
        disabled: _ctx.disabled,
        type: _ctx.type,
        variant: _ctx.variant,
        onClick: handleClick
      }, {
        icon: withCtx(() => [
          renderSlot(_ctx.$slots, "icon", {}, () => [
            isLoading.value ? (openBlock(), createBlock(unref(NcLoadingIcon), {
              key: 0,
              name: unref(t)("Loading …")
              /* TRANSLATORS: The button is in a loading state*/
            }, null, 8, ["name"])) : _ctx.icon !== void 0 ? (openBlock(), createBlock(unref(NcIconSvgWrapper), {
              key: 1,
              svg: _ctx.icon
            }, null, 8, ["svg"])) : createCommentVNode("", true)
          ])
        ]),
        default: withCtx(() => [
          createTextVNode(toDisplayString(_ctx.label) + " ", 1)
        ]),
        _: 3
      }, 8, ["aria-label", "disabled", "type", "variant"]);
    };
  }
});
export {
  _sfc_main as _
};
//# sourceMappingURL=NcDialogButton.vue_vue_type_script_setup_true_lang-Cibg1sIr.mjs.map
